module.exports = __webpack_public_path__ + "static/soaphead-bd5f3cff7fc300d9955cac812eee8abc.png";